import { memo, useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import _map from 'lodash/map';
import _join from 'lodash/join';
//Local files
import ClinicianPromptsDialog from 'components/Dialogs/ClinicianPrompts/ClinicianPrompts';
import ErrorWrapper from 'components/Common/ErrorWrapper/ErrorWrapper';
import useApp from 'hooks/useApp';
import useCustomSelector from 'hooks/useCustomSelector';
import useClinicians from 'hooks/useClinicians';
import { cliniciansSelectors } from 'features/clinicians';

const CliniciansDetails = () => {
  const { setClinicianDrawer } = useApp();
  const { clearLocalActiveClinician } = useClinicians();
  const { first_name, last_name, display_name, locations, injuries, prompt, filter_prompt, merge_prompt,  synchronized, slots_count, updated_at } = useCustomSelector(cliniciansSelectors.getClinicianData);
  const [clinicianPromptsDialog, setClinicianPromptsDialog] = useState({ open: false });
  const lastUpdate = new Date(updated_at).toLocaleDateString('en-US');

  const handleViewClinicianPrompts = () => setClinicianPromptsDialog({ open: true });
  const handleCloseClinicianPrompts = () => setClinicianPromptsDialog({ open: false });

  useEffect(() => {
    return clearLocalActiveClinician;
  }, [clearLocalActiveClinician]);

  return (
    <Box sx={{ flexGrow: 1, overflow: 'auto', p: 5  }}>
      <Container maxWidth={'sm'}>
        <ClinicianPromptsDialog {...clinicianPromptsDialog} onClose={handleCloseClinicianPrompts} />
        <Card sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '8px', mb: 1.5 }}>

            <Typography sx={{ fontSize: '1.5rem', fontWeight: 800 }}>{`${first_name} ${last_name}`}</Typography>
            <Button variant='outlined' onClick={() => setClinicianDrawer({ open: true, edit: true })}>Edit</Button>
          </Box>
          <Typography noWrap variant='subtitle1'>Injuries: {_join(injuries, ', ')}</Typography>
          <Typography variant='subtitle1'>Display Name: {display_name ?? '-'}</Typography>
          <Typography noWrap variant='subtitle1'>Locations: {_join(_map(locations, 'name'), ', ')}</Typography>
          <Typography variant='subtitle1'>EHR match status: {synchronized ? 'Connected' : 'Not connected'}</Typography>
          <Typography variant='subtitle1'>Slots Count: {slots_count}</Typography>
          <Typography variant='body1' mb={2}>Last Update: {lastUpdate}</Typography>
        </Card>
        <Card sx={{ p: 2, mt: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '8px', mb: 1.5 }}>
            <Typography sx={{ fontSize: '1.5rem', fontWeight: 800 }}>Prompts</Typography>
            <Button variant='outlined' onClick={handleViewClinicianPrompts}>Edit</Button>
          </Box>
          <Typography noWrap sx={{ fontSize: '1.2rem', fontWeight: 400 }}>Filter Prompt: {filter_prompt || '-'}</Typography>
          <Typography noWrap sx={{ fontSize: '1.2rem', fontWeight: 400 }}>Merge Prompt: {merge_prompt || '-'}</Typography>
          <Typography noWrap sx={{ fontSize: '1.2rem', fontWeight: 400 }}>Scheduling rules: {prompt || '-'}</Typography>
        </Card>
      </Container>
    </Box>
  );
};

const WrappedComponent = props => {
  return (
    <ErrorWrapper>
      <CliniciansDetails {...props} />
    </ErrorWrapper>
  );
};

export default memo(WrappedComponent);